export const editorActionTypes = {
  NOTE: 'NOTE',
  MESSAGE: 'MESSAGE',
  RESOLUTION: 'RESOLUTION',
  RICH_TEXT_FIELD: 'RICH_TEXT_FIELD',
  ACTIVITY: 'ACTIVITY',
};
